"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// @ts-strict-ignore
// Modified from https://github.com/palmerhq/radio-group
var react_1 = require("react");
var uuid_1 = require("uuid");
var shared_1 = require("./shared");
var RadioGroup = function (_a) {
    var labelledBy = _a.labelledBy, children = _a.children, onChange = _a.onChange, value = _a.value, props = __rest(_a, ["labelledBy", "children", "onChange", "value"]);
    var groupId = (0, react_1.useMemo)(function () { return (0, uuid_1.v4)(); }, []);
    var setChecked = (0, react_1.useCallback)(function (v) {
        if (onChange) {
            onChange(v);
        }
    }, [onChange]);
    var otherRadioValues = react_1.Children.map(children, function (child) { return child.props.value; });
    var ctx = (0, react_1.useMemo)(function () { return ({
        groupId: groupId,
        otherRadioValues: otherRadioValues,
        setChecked: setChecked,
        value: value
    }); }, [groupId, otherRadioValues, setChecked, value]);
    return ((0, jsx_runtime_1.jsx)(shared_1.RadioGroupContext.Provider, __assign({ value: ctx }, { children: (0, jsx_runtime_1.jsx)("div", __assign({}, props, { "aria-labelledby": labelledBy, role: "radiogroup" }, { children: children })) })));
};
exports.default = RadioGroup;
